import {
  OUTLET_PAGE_ASK_REACTIVATE_OUTLET_WITHOUT_PAY,
  OUTLET_PAGE_CONFIRM_REACTIVATE_OUTLET_WITHOUT_PAY,
  OUTLET_PAGE_HIDE_REACTIVATE_OUTLET_WITHOUT_PAY,
  OUTLET_PAGE_LIST_ASK_REACTIVATE_OUTLET,
  OUTLET_PAGE_LIST_CANCEL_REACTIVATE_OUTLET,
  OUTLET_PAGE_LIST_CLICK_ADD_OUTLET,
  OUTLET_PAGE_LIST_CLICK_CANCEL,
  OUTLET_PAGE_LIST_CLICK_CREATE_OUTLET,
  OUTLET_PAGE_LIST_CLICK_OUTLET_ROW,
  OUTLET_PAGE_LIST_CLOSE_RIGHT_COLUMN,
  OUTLET_PAGE_LIST_CONFIRM_REACTIVATE_OUTLET,
  OUTLET_PAGE_LIST_DISABLE_PAY_BUTTON,
  OUTLET_PAGE_LIST_ENABLE_PAY_BUTTON,
  OUTLET_PAGE_LIST_GET_BILLING,
  OUTLET_PAGE_LIST_GET_OUTLET_PRICE,
  OUTLET_PAGE_LIST_GET_SUBSCRIPTION_STATUS,
  OUTLET_PAGE_LIST_HIDE_ADD_OUTLET_MODAL,
  OUTLET_PAGE_LIST_HIDE_CONFIRM_REACTIVATE_OUTLET_MODAL,
  OUTLET_PAGE_LIST_HIDE_PAYMENT_GATEWAY_ERROR_MODAL,
  OUTLET_PAGE_LIST_OPEN_RIGHT_COLUMN,
  OUTLET_PAGE_LIST_PAGE_REQUEST,
  OUTLET_PAGE_LIST_SEARCH,
  OUTLET_PAGE_LIST_SET_ON_LOADING,
  OUTLET_PAGE_LIST_SET_OUTLET_DETAIL,
  OUTLET_PAGE_LIST_SET_OUTLET_PRICE,
  OUTLET_PAGE_LIST_SET_OUTLET_SLOTS,
  OUTLET_PAGE_LIST_SET_OUTLETS,
  OUTLET_PAGE_LIST_SET_PAY_BUTTON_MESSAGE,
  OUTLET_PAGE_LIST_SET_PENDING_PAYMENT_MESSAGE,
  OUTLET_PAGE_LIST_SET_PROFILE,
  OUTLET_PAGE_LIST_SET_REACTIVATED_OUTLET,
  OUTLET_PAGE_LIST_SET_SUBSCRIPTION_STATUS,
  OUTLET_PAGE_LIST_SET_USED_OUTLET_SLOTS,
  OUTLET_PAGE_LIST_SHOW_ADD_OUTLET_MODAL,
  OUTLET_PAGE_LIST_SHOW_CONFIRM_REACTIVATE_OUTLET_MODAL,
  OUTLET_PAGE_LIST_SHOW_PAYMENT_GATEWAY_ERROR_MODAL,
  OUTLET_PAGE_LIST_SUBMIT_FORM_CREATE,
  OUTLET_PAGE_LIST_SUBMIT_FORM_UPDATE,
  OUTLET_PAGE_LIST_VERIFY_ADD_OUTLET_BILLING_DATA,
  OUTLET_PAGE_LIST_SET_DISABLE_SAVE_OUTLET_BUTTON,
  OUTLET_PAGE_SHOW_REACTIVATE_OUTLET_WITHOUT_PAY,
  OUTLET_PAGE_SET_ON_LOADING_REACTIVATE_OUTLET_WITHOUT_PAY_MODAL,
  OUTLET_PAGE_SET_OPEN_PAYMENT_METHOD_MODAL,
  OUTLET_PAGE_SET_PAYMENT_METHOD_LIST,
  OUTLET_PAGE_SHOW_CLONE_OUTLET,
  OUTLET_PAGE_SHOW_CLONE_OUTLET_PROGRESS,
  OUTLET_PAGE_HIDE_CLONE_OUTLET_PROGRESS,
  OUTLET_PAGES_IS_STILL_CLONING,
  OUTLET_PAGES_UPDATE_CLONING_PROGRESS,
  OUTLET_PAGES_CLONE_SUCCESS,
  OUTLET_PAGES_CLONE_FAILED,
  OUTLET_PAGES_CLONE_RESET,
  OUTLET_PAGES_SUBMIT_CLONE_OUTLET,
  OUTLET_PAGES_SHOW_CLONE_NOTIFICATION,
  OUTLET_PAGES_CHECK_CLONE_ON_PROGRESS,
  OUTLET_PAGES_DELETE_CLONE_CACHE_ON_SUCCESS,
  OUTLET_PAGES_CHECK_CLONE_PROGRESS_CHANGED,
  OUTLET_PAGES_RESET_CLONING_PROGRESS,
  OUTLET_PAGES_POPULATE_CLONE_OUTLET_DATA,
  OUTLET_PAGES_SET_CLONE_OUTLET_DATA,
  OUTLET_PAGES_SET_CLONE_ELIGIBLE,
  OUTLET_PAGES_SET_CLONE_FORBIDDEN,
  OUTLET_PAGES_SET_CLONE_ID,
  OUTLET_PAGES_REMOVE_CLONE_ID,
  OUTLET_PAGES_HIDE_CLONE_NOTIFICATION,
  OUTLET_PAGES_CLONE_SUCCESS_AND_CONFIRMED,
  OUTLET_PAGE_LIST_HIDE_SAUDAGAR_INFO_MODAL,
  OUTLET_PAGE_LIST_SHOW_SAUDAGAR_INFO_MODAL,
  OUTLET_PAGES_ON_CHANGE_STATUS,
  OUTLET_PAGES_SET_GOBIZ_LINKING_MERCHANT_INFO,
  OUTLET_PAGES_SET_GOBIZ_LINKING_MERCHANT_INFO_REMOVED,
  OUTLET_PAGES_GOBIZ_OUTLET_LINKING_CONFIRMED,
  OUTLET_PAGES_GOBIZ_OUTLET_LINKING_SUCCESS,
  OUTLET_PAGES_PREPARE_GOBIZ_OUTLET_LINKING,
  OUTLET_PAGE_LIST_SHOW_GOBIZ_LINKING_RECOMMENDATION_MODAL,
  OUTLET_PAGE_LIST_SHOW_GOBIZ_LINKING_RECOMMENDATION_MODAL_CLOSED,
  OUTLET_PAGE_LIST_CLICK_OUTLET_DETAIL_ROW,
  OUTLET_PAGES_GOBIZ_OUTLET_RECOMMENDATION_ON_CHANGE_OUTLET,
  OUTLET_PAGE_LIST_SHOW_UNLINK_GOBIZ_MODAL,
  OUTLET_PAGE_LIST_SHOW_UNLINK_GOBIZ_MODAL_CLOSED,
  OUTLET_PAGE_LIST_UNLINK_GOBIZ_MODAL,
} from './constants';

export function pageRequest(billingNotification) {
  return {
    type: OUTLET_PAGE_LIST_PAGE_REQUEST,
    payload: { billingNotification },
  };
}

export function setProfile(profile) {
  return { type: OUTLET_PAGE_LIST_SET_PROFILE, payload: { profile } };
}

/**
 *
 * @param {Array} outlets
 * @return {{type, payload: {outlets: *}}}
 */
export function setOutlets(outlets) {
  return { type: OUTLET_PAGE_LIST_SET_OUTLETS, payload: { outlets } };
}

/**
 *
 * @param {object} outletDetail
 * @return {{type, payload: {outletDetail: *}}}
 */
export function setOutletDetail(outletDetail) {
  return {
    type: OUTLET_PAGE_LIST_SET_OUTLET_DETAIL,
    payload: { outletDetail },
  };
}

export function search(keyword, status) {
  return { type: OUTLET_PAGE_LIST_SEARCH, payload: { keyword, status } };
}

export function showSaudagarInfoModal(moka, saudagar) {
  return {
    type: OUTLET_PAGE_LIST_SHOW_SAUDAGAR_INFO_MODAL,
    payload: { moka, saudagar },
  };
}

export function showUnlinkGoBizModal(moka, saudagar) {
  return {
    type: OUTLET_PAGE_LIST_SHOW_UNLINK_GOBIZ_MODAL,
    payload: { moka, saudagar },
  };
}

export function hideUnlinkGoBizModal() {
  return {
    type: OUTLET_PAGE_LIST_SHOW_UNLINK_GOBIZ_MODAL_CLOSED,
  };
}

export function unlinkGoBizLinking(outletId, outlets) {
  return {
    type: OUTLET_PAGE_LIST_UNLINK_GOBIZ_MODAL,
    payload: { outletId, outlets },
  };
}

export function hideSaudagarInfoModal() {
  return {
    type: OUTLET_PAGE_LIST_HIDE_SAUDAGAR_INFO_MODAL,
  };
}

export function clickOutletRow(outletId) {
  return { type: OUTLET_PAGE_LIST_CLICK_OUTLET_ROW, payload: { outletId } };
}

export function clickCancel() {
  return { type: OUTLET_PAGE_LIST_CLICK_CANCEL, payload: {} };
}

export function clickCreateOutlet() {
  return { type: OUTLET_PAGE_LIST_CLICK_CREATE_OUTLET, payload: {} };
}

export function clickAddOutlet() {
  return { type: OUTLET_PAGE_LIST_CLICK_ADD_OUTLET, payload: {} };
}

export function setOutletSlots(slots) {
  return { type: OUTLET_PAGE_LIST_SET_OUTLET_SLOTS, payload: { slots } };
}

export function setUsedOutletSlots(slots) {
  return { type: OUTLET_PAGE_LIST_SET_USED_OUTLET_SLOTS, payload: { slots } };
}

export function submitFormCreate(
  data,
  params,
  previousOutlets,
  paymentMethodList,
  isSubscribed
) {
  return {
    type: OUTLET_PAGE_LIST_SUBMIT_FORM_CREATE,
    payload: { data, params, previousOutlets, paymentMethodList, isSubscribed },
  };
}

export function submitFormUpdate(outletId, data, params, previousOutlets) {
  return {
    type: OUTLET_PAGE_LIST_SUBMIT_FORM_UPDATE,
    payload: { outletId, data, params, previousOutlets },
  };
}

export function showConfirmReactivateOutletModal() {
  return {
    type: OUTLET_PAGE_LIST_SHOW_CONFIRM_REACTIVATE_OUTLET_MODAL,
    payload: {},
  };
}

export function hideConfirmReactivateOutletModal() {
  return {
    type: OUTLET_PAGE_LIST_HIDE_CONFIRM_REACTIVATE_OUTLET_MODAL,
    payload: {},
  };
}

export function askReactivateOutlet(outlet) {
  return { type: OUTLET_PAGE_LIST_ASK_REACTIVATE_OUTLET, payload: { outlet } };
}

export function cancelReactivateOutlet() {
  return { type: OUTLET_PAGE_LIST_CANCEL_REACTIVATE_OUTLET, payload: {} };
}

export function confirmReactivateOutlet(billingData) {
  return {
    type: OUTLET_PAGE_LIST_CONFIRM_REACTIVATE_OUTLET,
    payload: { billingData },
  };
}

export function setReactivatedOutlet(outlet) {
  return { type: OUTLET_PAGE_LIST_SET_REACTIVATED_OUTLET, payload: { outlet } };
}

export function openRightColumn() {
  return { type: OUTLET_PAGE_LIST_OPEN_RIGHT_COLUMN, payload: {} };
}

export function closeRightColumn() {
  return { type: OUTLET_PAGE_LIST_CLOSE_RIGHT_COLUMN, payload: {} };
}

export function showAddOutletModal() {
  return { type: OUTLET_PAGE_LIST_SHOW_ADD_OUTLET_MODAL };
}

export function hideAddOutletModal() {
  return { type: OUTLET_PAGE_LIST_HIDE_ADD_OUTLET_MODAL };
}

export function getOutletPrice() {
  return { type: OUTLET_PAGE_LIST_GET_OUTLET_PRICE };
}

export function setOutletPrice(outletPrice) {
  return { type: OUTLET_PAGE_LIST_SET_OUTLET_PRICE, payload: { outletPrice } };
}

export function getFeatureSubscriptionStatus() {
  return { type: OUTLET_PAGE_LIST_GET_SUBSCRIPTION_STATUS };
}

export function setFeatureSubscriptionStatus(featureSubscriptions) {
  return {
    type: OUTLET_PAGE_LIST_SET_SUBSCRIPTION_STATUS,
    payload: { featureSubscriptions },
  };
}

export function verifyAddOutletBilling(billingData) {
  return {
    type: OUTLET_PAGE_LIST_VERIFY_ADD_OUTLET_BILLING_DATA,
    payload: { billingData },
  };
}

export function showPaymentGatewayError() {
  return { type: OUTLET_PAGE_LIST_SHOW_PAYMENT_GATEWAY_ERROR_MODAL };
}

export function hidePaymentGatewayError() {
  return { type: OUTLET_PAGE_LIST_HIDE_PAYMENT_GATEWAY_ERROR_MODAL };
}

export function setPaymentButtonMessage(buttonMessage) {
  return {
    type: OUTLET_PAGE_LIST_SET_PAY_BUTTON_MESSAGE,
    payload: { buttonMessage },
  };
}

export function enablePayButton() {
  return { type: OUTLET_PAGE_LIST_ENABLE_PAY_BUTTON };
}

export function disablePayButton() {
  return { type: OUTLET_PAGE_LIST_DISABLE_PAY_BUTTON };
}

export function setPendingPaymentMessage(pendingMessage) {
  return {
    type: OUTLET_PAGE_LIST_SET_PENDING_PAYMENT_MESSAGE,
    payload: { pendingMessage },
  };
}

export function getBilling() {
  return { type: OUTLET_PAGE_LIST_GET_BILLING };
}

export function setOnLoading(onLoading) {
  return { type: OUTLET_PAGE_LIST_SET_ON_LOADING, payload: { onLoading } };
}

export function setDisableSaveOutletButton(disabled) {
  return {
    type: OUTLET_PAGE_LIST_SET_DISABLE_SAVE_OUTLET_BUTTON,
    payload: { disabled },
  };
}

export function askReactivateOutletWithoutPay(outlet) {
  return {
    type: OUTLET_PAGE_ASK_REACTIVATE_OUTLET_WITHOUT_PAY,
    payload: { outlet },
  };
}

export function confirmReactivateOutletWithoutPay(outlet, previousOutlets) {
  return {
    type: OUTLET_PAGE_CONFIRM_REACTIVATE_OUTLET_WITHOUT_PAY,
    payload: { outlet, previousOutlets },
  };
}

export function showReactivateOutletWithoutPay() {
  return { type: OUTLET_PAGE_SHOW_REACTIVATE_OUTLET_WITHOUT_PAY };
}

export function hideReactivateOutletWithoutPay() {
  return { type: OUTLET_PAGE_HIDE_REACTIVATE_OUTLET_WITHOUT_PAY };
}

export function setOnLoadingReactivateOutletWithoutPay(isOnLoading) {
  return {
    type: OUTLET_PAGE_SET_ON_LOADING_REACTIVATE_OUTLET_WITHOUT_PAY_MODAL,
    payload: { isOnLoading },
  };
}

export function setOpenInformationModal(openPaymentMethodModal) {
  return {
    type: OUTLET_PAGE_SET_OPEN_PAYMENT_METHOD_MODAL,
    payload: { openPaymentMethodModal },
  };
}

export function setPaymentMethodsList(paymentMethodList) {
  return {
    type: OUTLET_PAGE_SET_PAYMENT_METHOD_LIST,
    payload: { paymentMethodList },
  };
}

export function showCloneOutletOption(showOption) {
  return {
    type: OUTLET_PAGE_SHOW_CLONE_OUTLET,
    payload: { showOption },
  };
}

export function showCloneOutletProgress(outlet) {
  return {
    type: OUTLET_PAGE_SHOW_CLONE_OUTLET_PROGRESS,
    payload: { outlet },
  };
}

export function hideCloneOutletProgress() {
  return {
    type: OUTLET_PAGE_HIDE_CLONE_OUTLET_PROGRESS,
  };
}

export function isCloning() {
  return {
    type: OUTLET_PAGES_IS_STILL_CLONING,
  };
}

export function updateCloningProgress(progress) {
  return {
    type: OUTLET_PAGES_UPDATE_CLONING_PROGRESS,
    payload: { progress },
  };
}

export function resetCloningProgress() {
  return {
    type: OUTLET_PAGES_RESET_CLONING_PROGRESS,
  };
}

export function setCloneSuccess(outlet) {
  return {
    type: OUTLET_PAGES_CLONE_SUCCESS,
    payload: { outlet },
  };
}

export function setCloneFailed(outlet) {
  return {
    type: OUTLET_PAGES_CLONE_FAILED,
    payload: { outlet },
  };
}

export function resetCloneResult() {
  return {
    type: OUTLET_PAGES_CLONE_RESET,
  };
}

export function submitCloneOutlet(outlet) {
  return {
    type: OUTLET_PAGES_SUBMIT_CLONE_OUTLET,
    payload: { outlet },
  };
}

export function showCloneOutletNotification(notification) {
  return {
    type: OUTLET_PAGES_SHOW_CLONE_NOTIFICATION,
    payload: { notification },
  };
}

export function hideCloneOutletNofication() {
  return {
    type: OUTLET_PAGES_HIDE_CLONE_NOTIFICATION,
  };
}

export function checkCloningOutletOnProgress() {
  return {
    type: OUTLET_PAGES_CHECK_CLONE_ON_PROGRESS,
    payload: {},
  };
}

export function checkCloningOutletProgressChanges(data) {
  return {
    type: OUTLET_PAGES_CHECK_CLONE_PROGRESS_CHANGED,
    payload: { data },
  };
}

export function deleteCloneCacheOnSuccess() {
  return {
    type: OUTLET_PAGES_DELETE_CLONE_CACHE_ON_SUCCESS,
  };
}

export function cloneSuccessAndConfirmed(data) {
  return {
    type: OUTLET_PAGES_CLONE_SUCCESS_AND_CONFIRMED,
    payload: { data },
  };
}

export function populateCloneOutletData() {
  return {
    type: OUTLET_PAGES_POPULATE_CLONE_OUTLET_DATA,
  };
}

export function setCloneOutletData(data) {
  return {
    type: OUTLET_PAGES_SET_CLONE_OUTLET_DATA,
    payload: { data },
  };
}

export function setCloningEligible() {
  return {
    type: OUTLET_PAGES_SET_CLONE_ELIGIBLE,
  };
}

export function setCloningForbidden() {
  return {
    type: OUTLET_PAGES_SET_CLONE_FORBIDDEN,
  };
}

export function setCloneOutletId(id) {
  return {
    type: OUTLET_PAGES_SET_CLONE_ID,
    payload: { id },
  };
}

export function removeCloneOutletId() {
  return {
    type: OUTLET_PAGES_REMOVE_CLONE_ID,
  };
}

export function onChangeStatus(keyword, status) {
  return {
    type: OUTLET_PAGES_ON_CHANGE_STATUS,
    payload: { keyword, status },
  };
}

export function setGoBizLinkingMerchantInfo(moka, merchantInfo) {
  return {
    type: OUTLET_PAGES_SET_GOBIZ_LINKING_MERCHANT_INFO,
    payload: { moka, merchantInfo },
  };
}

export function hideGoBizOutletLinkingModal() {
  return {
    type: OUTLET_PAGES_SET_GOBIZ_LINKING_MERCHANT_INFO_REMOVED,
  };
}

export function prepareGoBizOutletLinking(authCode, error) {
  return {
    type: OUTLET_PAGES_PREPARE_GOBIZ_OUTLET_LINKING,
    payload: { authCode, error },
  };
}

export function confirmGoBizOutletLinking(saudagar, outlets) {
  return {
    type: OUTLET_PAGES_GOBIZ_OUTLET_LINKING_CONFIRMED,
    payload: { saudagar, outlets },
  };
}

export function goBizOutletLinkingSuccess() {
  return {
    type: OUTLET_PAGES_GOBIZ_OUTLET_LINKING_SUCCESS,
  };
}

export function showGoBizLinkingRecommendation(moka, saudagar) {
  return {
    type: OUTLET_PAGE_LIST_SHOW_GOBIZ_LINKING_RECOMMENDATION_MODAL,
    payload: { moka, saudagar },
  };
}

export function hideGobizLinkingRecommendationModal() {
  return {
    type: OUTLET_PAGE_LIST_SHOW_GOBIZ_LINKING_RECOMMENDATION_MODAL_CLOSED,
  };
}

export function clickOutletDetailRow(outlet) {
  return {
    type: OUTLET_PAGE_LIST_CLICK_OUTLET_DETAIL_ROW,
    payload: { outlet },
  };
}

export function onRecommendationModalChangeGobizOutlet(outlet) {
  return {
    type: OUTLET_PAGES_GOBIZ_OUTLET_RECOMMENDATION_ON_CHANGE_OUTLET,
    payload: { outlet },
  };
}
